// extracted by mini-css-extract-plugin
export var treatmentSection = "styles-module--treatmentSection--CV-Ku";
export var methodsDescriptionWrapper = "styles-module--methodsDescriptionWrapper--nRvOO";
export var methodsImageDiv = "styles-module--methodsImageDiv--0uJzK";
export var methodsTextDiv = "styles-module--methodsTextDiv--O3T3n";
export var methodsListTitle = "styles-module--methodsListTitle--+Wn5c";
export var moreDescriptionGrid = "styles-module--moreDescriptionGrid--BdrPl";
export var treatmentMethodDescription = "styles-module--treatmentMethodDescription--apwas";
export var showMoreButton = "styles-module--showMoreButton--bTA9V";
export var hideMoreInfo = "styles-module--hideMoreInfo--2r29J";